import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-bill-to-type',
  templateUrl: './bill-to-type.component.html',
  styleUrls: ['./bill-to-type.component.scss'],
})
export class BillToTypeComponent implements OnInit, OnChanges {
  public billTo: string[];
  public selected?: string;
  @Input() public disabled = false;
  @Output() public selection = new EventEmitter<string>();
  @Input() public defaultValue = '';

  constructor() {
    this.billTo = ['INSURANCE', 'CLIENT', 'PATIENT'];
  }

  public valueChanged() {
    this.selection.emit(this.selected);
  }

  public ngOnInit() {
    if (this.selected === undefined) {
      this.selected = this.billTo[2];
    }

    this.valueChanged();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultValue) {
      this.selected = changes.defaultValue.currentValue;
      this.valueChanged();
    }
  }
}
